import { Link2 } from "lucide-react";
import { SimpleDropdown } from "./dropdown";
import { LinkActivityItem } from "./link-activity-item";
import {
  DiscoveryActivityItem,
  DiscoverySort,
  DiscoveryStatusFilter,
  SORT_OPTIONS,
  STATUS_FILTER_OPTIONS,
} from "./types";
import { DateRange, PeriodDropdown, PeriodValue } from "../../../components/period-filter";

interface LinkActivityProps {
  items: DiscoveryActivityItem[];
  loading: boolean;
  sort: DiscoverySort;
  onSortChange: (sort: DiscoverySort) => void;
  statusFilter: DiscoveryStatusFilter;
  onStatusFilterChange: (status: DiscoveryStatusFilter) => void;
  period: PeriodValue;
  onPeriodChange: (period: PeriodValue) => void;
  customRange: DateRange;
  onCustomRangeChange: (range: DateRange) => void;
  onToggleActive: (id: number) => void;
}

export const LinkActivity: React.FC<LinkActivityProps> = ({
  items,
  loading,
  sort,
  onSortChange,
  statusFilter,
  onStatusFilterChange,
  period,
  onPeriodChange,
  customRange,
  onCustomRangeChange,
  onToggleActive,
}) => (
  <div className="bg-white rounded-[24px] p-4 sm:p-6 shadow-sm border border-gray-100">
    {/* Filters bar */}
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-5">
      <span className="text-gray-400">
        <Link2 size={18} />
      </span>
      <div className="flex flex-wrap items-center gap-2">
        <SimpleDropdown value={sort} options={SORT_OPTIONS} onChange={onSortChange} />
        <SimpleDropdown value={statusFilter} options={STATUS_FILTER_OPTIONS} onChange={onStatusFilterChange} />
        <PeriodDropdown value={period} onChange={onPeriodChange} customRange={customRange} onCustomRangeChange={onCustomRangeChange} />
      </div>
    </div>

    <h2 className="text-lg font-bold text-black">Discovery Link Activity</h2>
    <p className="text-sm text-[#65799A] mb-2">
      Track generated Discovery VouchLinks, qualification progress, clicks and rewards.
    </p>

    <div>
      {loading ? (
        <div className="py-16 text-center text-gray-400">Loading discovery links...</div>
      ) : items.length === 0 ? (
        <div className="py-16 text-center text-gray-400">No discovery links match this filter.</div>
      ) : (
        items.map((item) => (
          <LinkActivityItem key={item.id} item={item} onToggleActive={() => onToggleActive(item.id)} />
        ))
      )}
    </div>
  </div>
);
